import React from 'react';
import Stack from '@mui/material/Stack';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CustomDatePicker from './CustomDatePicker';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../shared-theme/ColorModeIconDropdown';
import ShiftButton from './ShiftButton';
import Divider from '@mui/material/Divider';

export default function Header({ pageTitle, selectedDate, setSelectedDate }) {
  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs pageTitle={pageTitle} />
      <Stack direction="row" sx={{ gap: 1 }}>
      {pageTitle !== 'Startseite' ? (
        <CustomDatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        ) : null}

        <ColorModeIconDropdown />
        <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
        <ShiftButton selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
      </Stack>
    </Stack>
  );
}
